<!--
 * @Desc: 
 * @Author: 赵佳明
 * @Date: 2022-03-22 08:51:15
 * @LastEditors: 赵佳明
 * @LastEditTime: 2024-04-09 14:48:57
-->
<template>
	<div class="gwh_footer">
		<!-- 下拉 -->
		<div class="xiala">
			<div class="inner">
				<select onchange="javascript:window.open(this.options[this.selectedIndex].value)">
					<option>--省直各部门网站--</option>
					<option :value="item.url" v-for="(item,index) in linkInfo.nongyeting" :key="index">{{item.name||''}}</option>
				</select>
				<select onchange="javascript:window.open(this.options[this.selectedIndex].value)">
					<option>--衡水县市区网站--</option>
					<option :value="item.url" v-for="(item,index) in linkInfo.shixiandata" :key="index">{{item.name||''}}</option>
				</select>
				<select onchange="javascript:window.open(this.options[this.selectedIndex].value)">
					<option>--新闻媒体网站--</option>
					<option :value="item.url" v-for="(item,index) in linkInfo.xinmeitidata" :key="index">{{item.name||''}}</option>
				</select>
			</div>
		</div>
		<!-- 信息 -->
		<div class="footInfo inner">
			<div class="word">
				<div>
					<span>主办：河北衡水高新技术产业开发区管理委员会</span>
					<span>联系方式：0318-2111501</span>
				</div>
				<div>
					<span>网站标识：1311000037</span>
					<span>公安备案：13110802000107</span>
				</div>
				<div>
					<span>地址:衡水市永兴西路1988号</span>
					<span @click="toIcp" class="icp">冀ICP备16022288号-1</span>
					<span @click="toMap" class="footer_map">网站地图</span>
				</div>
			</div>
			<div class="pic">
				<a href="http://bszs.conac.cn/sitename?method=show&id=549184CDD04C0CC5E053012819ACDE75" target="_blank">
					<img src="/statics/image/index/red.png" alt />
				</a>
				<!-- <a
          href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=1311000037&url="
          target="_blank"
        >-->
				<a href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=1311000037&url=http%3A%2F%2Fwww.hskfq.gov.cn%2F"
					target="_blank">
					<img src="/statics/image/index/jiucuo.png" alt />
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			linkInfo:{
				nongyeting:[],//省直各部门网站
				shixiandata:[],//衡水县市区网站
				xinmeitidata:[]//新闻媒体网站
			}
		};
	},
	created() {
		this.getLink()
	},
	methods: {
		toMap() {
			this.$router.push({
				path: "/wz_map",
			});
		},
		toIcp() {
			window.open("https://beian.miit.gov.cn/#/Integrated/index");
		},
		getLink() {
			var that = this;
			that.$api.index.link({}).then(function (res) {
				if (res.code == 200) {
					that.linkInfo = res.result;
				}
			});
		}
	},
	watch: {},
};
</script>

<style></style>
